import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="COVID-19 Tracker Web App" link="https://covid19-liveupdates.netlify.app/" bg="linear-gradient(to right, #081935 0%, #2cb480 100%)" mdxType="ProjectCard">
It is a COVID-19 worldwide tracker which uses various apis to keep updated information and stats. It has global, search by country option as well as latest covid19 news updates.
    </ProjectCard>
    <ProjectCard title="Aeolus Weather App" link="https://aeolus.netlify.app/" bg="linear-gradient(to right, #081935 0%, #2cb480 100%)" mdxType="ProjectCard">
Aeolus is a wether app made using vanilla js and with help of Openweathermap API. It use iplocation to find the temperature and atmosphere of the location of device. More features like UV index and other wether related stuff will soon be added.
    </ProjectCard>
    <ProjectCard title="Predulive Website" link="https://shivam0110.github.io/NGO-Website/" bg="linear-gradient(to right, #081935 0%, #2cb480 100%)" mdxType="ProjectCard">
I created a Website for Predulive Edutech foundation, with all pages like Our Work, Media centre, resources, Contact Us, login, etc. Its an ideal for evry NGO/Foundation.
    </ProjectCard>
    <ProjectCard title="Ethical Hacking tools" link="https://github.com/shivam0110/Ethical-Hacking" bg="linear-gradient(to right, #081935 0%, #2cb480 100%)" mdxType="ProjectCard">
In this brief stint of Hacking I created codes for malwares, keylogger for Window using C language. It has a C code for backdoor and server file and its debian based.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      